import React from "react";
import PropTypes from "prop-types";
import Img from "gatsby-image";
import Masonry from "react-masonry-css";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { MediaGalleryCardHolderDiv, MediaGalleryCard } from "./elements";
import VideoModal from "../VideoModal";
import { useState } from "react";

const MediaGalleryCardHolder = ({ cards }) => {
  const videoExtensions = ["mp4", "webm"];

  const [urls, setUrls] = useState(null);

  const onOpenModal = (localFile) => {
    setUrls({
      urlMp4: localFile?.extension === "mp4" ? localFile?.publicURL : null,
      urlWebm: localFile?.extension === "webm" ? localFile?.publicURL : null,
    });
  };
  const onCloseModal = () => {
    setUrls(null);
  };

  return (
    <MediaGalleryCardHolderDiv>
      {cards?.length ? (
        <Masonry breakpointCols={{ default: 4, 1270: 3, 950: 2, 635: 1 }} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
          {cards?.map((card, index) => {
            return (
              <MediaGalleryCard key={index}>
                {card?.localFile?.childImageSharp ? (
                  <Zoom>
                    <Img fluid={card?.localFile?.childImageSharp?.fluid} />
                  </Zoom>
                ) : null}
                {card?.localFile?.extension === "gif" && card?.localFile?.publicURL ? (
                  <Zoom>
                    <img src={card?.localFile?.publicURL} />
                  </Zoom>
                ) : null}
                {videoExtensions.includes(card?.localFile?.extension) && card?.localFile?.publicURL ? (
                  <div onClick={() => onOpenModal(card?.localFile)}>
                    <video autoPlay muted loop playsInline>
                      {card?.localFile?.extension === "mp4" ? (
                        <source src={card?.localFile?.publicURL} type="video/mp4" data-wf-ignore="true" />
                      ) : null}
                      {card?.localFile?.extension === "webm" ? (
                        <source src={card?.localFile?.publicURL} type="video/webm" data-wf-ignore="true" />
                      ) : null}
                    </video>
                  </div>
                ) : null}
              </MediaGalleryCard>
            );
          })}
        </Masonry>
      ) : (
        <p>Coming soon!</p>
      )}
      <VideoModal open={!!urls} urls={urls} onClose={onCloseModal} />
    </MediaGalleryCardHolderDiv>
  );
};

export default MediaGalleryCardHolder;
